module.exports = __webpack_public_path__ + "img/8.a65a116.svg";